import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function InformationHome() {
    return (
        <MKBox component="section" pt={{ xs: 8, md: 10 }} pb={{ xs: 3, md: 5 }}>
            <Container>
                <Grid container item xs={12} lg={10} justifyContent="center" sx={{ mx: "auto" }}>
                    <MKTypography variant="h2" color="dark" mb={3} sx={{ textWrap: "balance" }}>
                        Curățenie de întreținere
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Curățenia de întreținere este un proces sistematic de menținere a unui
                        standard de curățenie esențial unui mediu curat, sănătos și plăcut
                        activităților desfășurate zi de zi.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Pentru întreținerea spațiului dumneavoastră, serviciile noastre includ și
                        intervenții generale periodice, realizate la o anumită frecvență agreată
                        împreună cu beneficiarul. Astfel, toate suprafețele rămân impecabile și pot
                        fi întreținute corespunzător de operatorii noștri. Acest tip de curățenie de
                        întreținere este utilizat de peste 90% dintre companiile cu care colaborăm.
                        Personalul alocat se ocupă exclusiv de întreținerea locațiilor, respectând
                        caietele de sarcini, cerințele și necesitățile fiecărui beneficiar.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" sx={{ textWrap: "pretty" }}>
                        Întreținerea zilnică se poate realiza în ture de zi, program de noapte sau
                        prin întreținere part-time, adaptată programului și spațiului, unde structura
                        și frecvența intervențiilor sunt ajustate în funcție de solicitările
                        clientului, productivitate sau evenimente speciale.
                    </MKTypography>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
